exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-1c4cde27],.fade-leave-active[data-v-1c4cde27]{transition:all .2s linear;transform:translate3D(0,0,0)}.fade-enter[data-v-1c4cde27],.fade-leave-active[data-v-1c4cde27]{transform:translate3D(100%,0,0)}.img-view[data-v-1c4cde27]{width:100%;height:100%;cursor:pointer}.img-view .img-layer[data-v-1c4cde27]{position:fixed;z-index:999;top:0;left:0;background:rgba(0,0,0,.7);width:100%;height:100%;overflow:hidden;cursor:pointer}.img-view .img div[data-v-1c4cde27]{max-width:100%;display:block;position:absolute;left:0;right:0;top:0;text-align:center;z-index:1000}.img-view .img .infos[data-v-1c4cde27]{z-index:10000}.img-view .img img[data-v-1c4cde27]{max-width:50%;display:block;position:absolute;left:0;right:0;top:36px;margin:auto;z-index:1000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-1c4cde27&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/user/userM/BigImg.vue
// module id = 463
// module chunks = 0